/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FeedbackType = {
    PRODUCT: 'PRODUCT',
    SITE: 'SITE',
    CALLCENTER: 'CALLCENTER',
    DELIVERY: 'DELIVERY',
    SUPPORT: 'SUPPORT',
    CASHBOX: 'CASHBOX',
    DECOR: 'DECOR'
} as const;
export type FeedbackType = typeof FeedbackType[keyof typeof FeedbackType];

